import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { BHFilter } from '@adornis/buchungsheld-db/entities/bh-filter.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';

@Entity()
export class AdminInstitutionViewSetting extends MongoEntity {
  static override _class = 'AdminInstitutionViewSetting';
  static override _collectionName = 'admin-institution-view-settings';

  @Field(type => String)
  institutionID!: string;

  @Field(type => String)
  userID!: string;

  @Field(type => String)
  selectedTimeframeID: Maybe<string>;

  @Field(type => AdornisFilter)
  institutionDetailsWorkshopsFilterV1: Maybe<AdornisFilter>;

  @Field(type => BHFilter)
  institutionDetailsWorkshopSetsFilterV1: Maybe<BHFilter>;

  @Field(type => BHFilter)
  institutionDetailsCounselingsFilterV1: Maybe<BHFilter>;

  @Field(type => BHFilter)
  institutionDetailsBundlesFilterV1: Maybe<BHFilter>;

  @Field(() => BHFilter)
  institutionDetailsUsersFilterV1: Maybe<BHFilter>;

  @Field(() => BHFilter)
  institutionDetailsLecturersFilterV1: Maybe<BHFilter>;

  @Field(() => BHFilter)
  institutionDetailsExportParticipationsFilterV1: Maybe<BHFilter>;

  @Field(() => BHFilter)
  institutionDetailsExportUsersFilterV1: Maybe<BHFilter>;

  @Field(() => BHFilter)
  institutionDetailsExportProductsFilterV1: Maybe<BHFilter>;
}
